import { render, staticRenderFns } from "./WorkGroupCard.vue?vue&type=template&id=706f65d6"
import script from "./WorkGroupCard.vue?vue&type=script&lang=js"
export * from "./WorkGroupCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports